import {
  GET_CATEGORIES_SUCCESS,
  GET_SALON_DETAILS_SUCCESS,
  ADD_SALON_IMAGE_SUCCESS,
  GET_ANALYTICS_SUCCESS,
  SET_SALON_USERS,
} from "../constants";

const initialState = {
  salonDetails: {},
  uploadedImages: {},
  analytics: [],
  salonUsers: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS: {
      return { ...state, salonDetails: {} };
    }
    case GET_SALON_DETAILS_SUCCESS:
      return {
        ...state,
        salonDetails: action.data,
        uploadedImages: action.data.image_urls,
      };
    case ADD_SALON_IMAGE_SUCCESS:
      return {
        ...state,
        uploadedImages: action.data,
      };
    case GET_ANALYTICS_SUCCESS:
      return {
        ...state,
        analytics: action.data,
      };
    case SET_SALON_USERS:
      return {
        ...state,
        salonUsers: action.data,
      };
    default:
      return state;
  }
};

export default reducer;
